// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { Polyline } from './polyline';


export class PolylineTree {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
__init(i:number, bb:flatbuffers.ByteBuffer):PolylineTree {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPolylineTree(bb:flatbuffers.ByteBuffer, obj?:PolylineTree):PolylineTree {
  return (obj || new PolylineTree()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPolylineTree(bb:flatbuffers.ByteBuffer, obj?:PolylineTree):PolylineTree {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new PolylineTree()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

guid():string|null
guid(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
guid(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

imageGuid():string|null
imageGuid(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
imageGuid(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

label():string|null
label(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
label(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

polylines(index: number, obj?:Polyline):Polyline|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new Polyline()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
}

polylinesLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

static startPolylineTree(builder:flatbuffers.Builder) {
  builder.startObject(4);
}

static addGuid(builder:flatbuffers.Builder, guidOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, guidOffset, 0);
}

static addImageGuid(builder:flatbuffers.Builder, imageGuidOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, imageGuidOffset, 0);
}

static addLabel(builder:flatbuffers.Builder, labelOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, labelOffset, 0);
}

static addPolylines(builder:flatbuffers.Builder, polylinesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, polylinesOffset, 0);
}

static createPolylinesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]!);
  }
  return builder.endVector();
}

static startPolylinesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static endPolylineTree(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createPolylineTree(builder:flatbuffers.Builder, guidOffset:flatbuffers.Offset, imageGuidOffset:flatbuffers.Offset, labelOffset:flatbuffers.Offset, polylinesOffset:flatbuffers.Offset):flatbuffers.Offset {
  PolylineTree.startPolylineTree(builder);
  PolylineTree.addGuid(builder, guidOffset);
  PolylineTree.addImageGuid(builder, imageGuidOffset);
  PolylineTree.addLabel(builder, labelOffset);
  PolylineTree.addPolylines(builder, polylinesOffset);
  return PolylineTree.endPolylineTree(builder);
}
}
